// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link":"LocationLink-45b9fece3161f7f0"};